const unicodeRange =
  'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF';

export const publicSans = {
  fontFamily: 'Public Sans Web',
  fontStyle: 'normal',
  fontWeight: 400,
  src: `
      local(''),
      url(https://assets.cdn.plurall.net/elo/fonts/PublicSans-Regular.woff2) format('woff2'),
      url(https://assets.cdn.plurall.net/elo/fonts/PublicSans-Regular.woff) format('woff'),
      url(https://assets.cdn.plurall.net/elo/fonts/PublicSans-Regular.ttf) format('truetype')
    `,
  unicodeRange,
};

export const publicSansSemiBold = {
  fontFamily: 'Public Sans Web',
  fontStyle: 'normal',
  fontDisplay: 'fallback',
  fontWeight: 600,
  src: `
      local(''),
      url(https://assets.cdn.plurall.net/elo/fonts/PublicSans-SemiBold.woff2) format('woff2'),
      url(https://assets.cdn.plurall.net/elo/fonts/PublicSans-SemiBold.woff) format('woff'),
      url(https://assets.cdn.plurall.net/elo/fonts/PublicSans-SemiBold.ttf) format('truetype');
    `,
  unicodeRange,
};

export const publicSansBold = {
  fontFamily: 'Public Sans Web',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 700,
  src: `
      local(''),
      url(https://assets.cdn.plurall.net/elo/fonts/PublicSans-Bold.woff2) format('woff2'),
      url(https://assets.cdn.plurall.net/elo/fonts/PublicSans-Bold.woff) format('woff'),
      url(https://assets.cdn.plurall.net/elo/fonts/PublicSans-Bold.ttf) format('truetype');
    `,
  unicodeRange,
};
